// extracted by mini-css-extract-plugin
module.exports = {"_dialog":"confirmationDialog__dialog__21MP7","_dialog__buttons":"confirmationDialog__dialog__buttons__1af_U"};